import React, { useState, useEffect } from 'react';

import DOgimg from "../../../../assets/images/Dogimg.png"
import logo from "../../../../assets/images/logo192.png"
import { Container } from "@mui/material";
import { keyframes } from '@emotion/react'

import { VideoBkMAin, Dogimg } from "./styles";
import styled from '@emotion/styled';
import { SectionHeading, SectionMainWrapper } from '../../../Styles/style';

const heartbeat = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(2);
  }
  100% {
    transform: scale(1);
  }
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HeartbeatImage = styled.img`
  animation: ${heartbeat} 1.5s infinite;
`;

const Section1_Header = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.src = DOgimg;

    image.onload = () => {
      setIsLoading(false);
    };

    image.onerror = () => {
      setIsLoading(false);
      setIsError(true);
    };

    return () => {
      // Clean up the image load and error event listeners
      image.onload = null;
      image.onerror = null;
    };
  }, []);


  return (
    <SectionMainWrapper p="7rem 0" id="home">
      <Container maxWidth="xl">
        {isLoading ? (
          <div className="loader">
            <ImageContainer>
              <HeartbeatImage loading="lazy" src={logo} alt="Dog" />
            </ImageContainer>
          </div>
        ) : isError ? (
          <div className="error">Error loading image</div>
        ) : (
          <VideoBkMAin>

            <SectionHeading p="40px 0" m="0" data-aos="flip-up" data-aos-easing="ease-in" data-aos-delay="400" data-aos-duration="600" data-aos-offset="0">
              The People's<br />
              Cryptocurrency </SectionHeading>

            <Dogimg data-aos="zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="800"
              data-aos-duration="400"
              data-aos-offset="0" src={DOgimg} loading="lazy" alt="image" />
          </VideoBkMAin>
        )}
           
      </Container>

    </SectionMainWrapper>
  );
};

export default Section1_Header;
